/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ACTIONS } from "./actions";

enum Role {
  Admin = "ADMIN",
  MspDashboard = "MSP_DASHBOARD",
  ReadOnly = "READ_ONLY",
  TeamLead = "TEAM_LEAD",
  AdminLite = "ADMIN_LITE",
}

/*
  - :visit -> route level access
  - :view / :display -> component level access
  - :add / :remove / :update -> dynamic action access (same as mutation prefixes in Apollo)
*/
export const rules = {
  [Role.Admin]: {
    static: [
      ACTIONS.visitDashboard,
      ACTIONS.visitHomepage,

      ACTIONS.visitApplications,
      ACTIONS.visitApplicationAdd,
      ACTIONS.visitApplicationDetails,
      ACTIONS.visitCostAnalysis,

      ACTIONS.visitEnvironmentDetails,
      ACTIONS.viewEnvironmentKpi,

      ACTIONS.visitEstateRecords,
      ACTIONS.visitEstateRecordsDetails,

      ACTIONS.visitDriftReport,

      ACTIONS.visitExternalIntegrations,

      ACTIONS.visitReservations,

      ACTIONS.visitAccounts,
      ACTIONS.visitAccountAdd,
      ACTIONS.visitAddBillingData,
      ACTIONS.visitAccountEdit,
      ACTIONS.visitAccountDetails,

      ACTIONS.visitCloudAccountDetails,

      ACTIONS.visitSearchResults,
      ACTIONS.visitNotifications,
      ACTIONS.visitUsersPermissions,
      ACTIONS.visitGlobalApiKeys,

      ACTIONS.visitCostSplittingRules,
      ACTIONS.visitMapping,
      ACTIONS.visitEmployees,

      ACTIONS.visitOrgUnitTypes,

      ACTIONS.visitBusinessContexts,
      ACTIONS.visitBusinessContextDetails,
      ACTIONS.visitBusinessContextStructure,

      ACTIONS.visitSettings,
      ACTIONS.visitReleaseNotes,
      ACTIONS.visitApiDocs,
      ACTIONS.visitArchive,
      ACTIONS.visitExport,
      ACTIONS.visitSavingsSuggestions,

      ACTIONS.viewSearchBox,
      ACTIONS.viewDefaultApplication,
      ACTIONS.viewDashboardCharts,
      ACTIONS.viewNotifications,
      ACTIONS.viewWorkflowKpis,

      ACTIONS.updateApplication,
      ACTIONS.updateApplicationOwner,
      ACTIONS.updateMapping,
      ACTIONS.updateDiscoveryRules,
      ACTIONS.updateSavingsSuggestions,
      ACTIONS.updateEnvironment,
      ACTIONS.updateBudget,
      ACTIONS.updatePerson,

      ACTIONS.addApplication,
      ACTIONS.addOrgUnit,
      ACTIONS.addEnvironment,
      ACTIONS.addPerson,

      ACTIONS.removeApplication,
      ACTIONS.removeEnvironment,
      ACTIONS.removePerson,

      ACTIONS.visitWorkflowAdd,
      ACTIONS.visitWorkflows,
      ACTIONS.visitWorkflowDetails,
      ACTIONS.updateWorkflow,

      ACTIONS.visitKpi,
    ],
  },
  [Role.TeamLead]: {
    static: [
      ACTIONS.visitDashboard,

      ACTIONS.visitApplications,
      ACTIONS.visitApplicationDetails,

      ACTIONS.visitEnvironmentDetails,

      ACTIONS.visitEstateRecords,
      ACTIONS.visitEstateRecordsDetails,

      ACTIONS.visitExport,

      ACTIONS.visitExternalIntegrations,

      ACTIONS.visitMapping,
      ACTIONS.visitEmployees,

      ACTIONS.visitReleaseNotes,

      ACTIONS.visitSavingsSuggestions,

      ACTIONS.addEnvironment,
      ACTIONS.addPerson,

      ACTIONS.removeEnvironment,
      ACTIONS.removePerson,

      ACTIONS.updateBudget,
      ACTIONS.updateApplication,
      ACTIONS.updateEnvironment,
      ACTIONS.updatePerson,
    ],
  },
  [Role.ReadOnly]: {
    static: [
      ACTIONS.visitApplications,
      ACTIONS.visitApplicationDetails,

      ACTIONS.visitEnvironmentDetails,

      ACTIONS.visitEstateRecordsDetails,

      ACTIONS.visitMapping,
      ACTIONS.visitEmployees,

      ACTIONS.viewDefaultApplication,
    ],
  },
  [Role.MspDashboard]: {
    static: [],
  },
  [Role.AdminLite]: {
    static: [
      ACTIONS.visitEstateRecords,
      ACTIONS.visitEstateRecordsDetails,
      ACTIONS.visitCostAnalysis,
      ACTIONS.visitAccounts,
      ACTIONS.visitAccountDetails,
      ACTIONS.visitAccountEdit,
      ACTIONS.visitUsersPermissions,
      ACTIONS.visitAddBillingData,

      ACTIONS.addPerson,
      ACTIONS.removePerson,
      ACTIONS.updatePerson,
    ],
  },
};
